import React, { useRef } from "react"
import Container from "../../Container"
import { Autoplay, Navigation } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import ReviewsCard from "./ReviewsCard"
import right_icon from "../../../images/home/right_icon.svg"
import "swiper/css"

function Reviews() {
  const swiperRef = useRef()
  return (
    <Container>
      <div className="mb-[268px]">
        <p className="uppercase text-[24px] mb-[30px] lg:mb-0 w-full text-center lg:text-[40px] lg:w-[800px] font-[700] leading-[34px] lg:leading-[68px]">
          happy client reviews
        </p>
        <div
          initial="offscreen"
          whileInView="onscreen"
          viewport={{ once: true, amount: 0.3 }}
          className="w-full relative py-8"
        >
          <div className="flex absolute -bottom-16 lg:bottom-6 lg:left-[42%] items-center gap-6">
            <div
              onClick={() => swiperRef.current?.slidePrev()}
              onKeyDown={() => console.log("here")}
              className={`w-[40px] cursor-pointer -translate-y-[50%] z-10 
            `}
            >
              <img
                className="w-full rotate-180  z-[100]"
                src={right_icon}
                alt=""
              />
            </div>
            <div
              onClick={() => swiperRef.current?.slideNext()}
              onKeyDown={() => console.log("here")}
              className={`w-[40px] cursor-pointer -translate-y-[50%] z-10 
            `}
            >
              <img className="w-full  z-[100]" src={right_icon} alt="" />
            </div>
          </div>

          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={5}
            breakpoints={{
              480: {
                slidesPerView: 1,
              },

              768: {
                slidesPerView: 1,
              },
              1024: {
                slidesPerView: 1,
              },
            }}
            className="   w-full "
            autoplay={{ delay: 15000, disableOnInteraction: false }}
            onBeforeInit={swiper => {
              swiperRef.current = swiper
            }}
            loop
          >
            <SwiperSlide className=" p-2">
              <ReviewsCard />
            </SwiperSlide>
            <SwiperSlide className=" p-2">
              <ReviewsCard />
            </SwiperSlide>
            <SwiperSlide className=" p-2">
              <ReviewsCard />
            </SwiperSlide>
            <SwiperSlide className=" p-2">
              <ReviewsCard />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </Container>
  )
}

export default Reviews
